import { render, staticRenderFns } from "./with-actions.vue?vue&type=template&id=279a6b6d&scoped=true"
import script from "./with-actions.vue?vue&type=script&lang=js"
export * from "./with-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a6b6d",
  null
  
)

export default component.exports